var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DataTable',{attrs:{"url":_vm.api.ACTIONS.CAPTAIN_RATINGS(_vm.$route.params.id),"enable-delete":false,"descending":"","sortable":false,"enable-edit":false,"enable-add":false,"title":false,"actions-extra-main":_vm.actionsExtraMain,"titles":_vm.titles,"formatter":_vm.formatters}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }